import React from 'react'
import { Link, useNavigate, useLocation } from 'react-router'
import { Nav, Navbar } from 'react-bootstrap'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'
import * as s from './Menu.scss'

const PublicMenu = () => {

    const navigate = useNavigate()
    const location = useLocation()
    const handleSelect = e => navigate(e)

    return (
        <div className={s.container}>
            <Navbar collapseOnSelect fixed='top' expand='md'
                className={s.baseMenu + ' ' + s.main}>
                <Navbar.Brand className={s.navbarBrand}>
                    <Link to={{ pathname: '/' }}>
                        <span className={s.redHerringsWordmark}>REDHERRINGS</span>
                    </Link>
                </Navbar.Brand>
                <Navbar.Toggle className={s.navbarToggle}>
                    <FontAwesomeIcon name='bars' />
                </Navbar.Toggle>
                <Navbar.Collapse className={s.navbarCollapse}>
                    <Nav className={s.nav} onSelect={e => handleSelect(e)} onClick={e => e.stopPropagation()}>
                        <Nav.Item className={s.item}><Nav.Link active={location.pathname === '/login'} eventKey='/login'>Login</Nav.Link></Nav.Item>
                        <Nav.Item className={s.item}><Nav.Link active={location.pathname === '/forgot-username'} eventKey='/forgot-username'>Forgot Username</Nav.Link></Nav.Item>
                        <Nav.Item className={s.item}><Nav.Link active={location.pathname === '/forgot-password'} eventKey='/forgot-password'>Forgot Password</Nav.Link></Nav.Item>
                        <Nav.Item className={s.item + ' ' + s.signupItem}><Nav.Link active={location.pathname === '/signup'} eventKey='/signup'>Sign Up</Nav.Link></Nav.Item>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        </div>
    )
}

export default PublicMenu
